module.exports = __webpack_public_path__ + "images/花筑院子全景_06-2.jpg?v=8af2fdde";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_06-2.jpg
 ** module id = 78
 ** module chunks = 1 2
 **/